import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/lib/fda";

const links = [
  { to: "/how-it-works", label: "How It Works" },
  { to: "/debt-options", label: "Debt Options" },
  { to: "/faqs", label: "FAQs" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-border/70 bg-sand/90 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center gap-4 px-5 py-4 lg:px-10">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link" aria-label="Freedom Debt Advice home">
          <img src="/logo-mark-dark.png" alt="" aria-hidden="true" className="h-10 w-10 shrink-0 object-contain" />
          <span className="leading-none">
            <span className="block font-display text-lg font-extrabold italic tracking-tight text-forest sm:text-xl">Freedom Debt Advice</span>
            <span className="mt-1 hidden text-[10px] font-bold uppercase tracking-[0.22em] text-moss sm:block">Helping hands for your debts</span>
          </span>
        </Link>

        <nav className="ml-auto hidden items-center gap-8 lg:flex" data-testid="desktop-nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.to.slice(1)}`}
              className={({ isActive }) => `text-sm font-semibold transition-colors hover:text-terracotta ${isActive ? "text-terracotta" : "text-forest-soft"}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <a href={`tel:${PHONE_TEL}`} data-testid="header-phone"
          className="ml-auto hidden items-center gap-2 text-sm font-bold text-forest transition-opacity hover:opacity-70 lg:ml-6 lg:flex">
          <Phone className="h-4 w-4" /> {PHONE}
        </a>
        <Link to="/check-my-options" data-testid="header-cta"
          className="hidden rounded-full bg-terracotta px-5 py-2.5 text-xs font-extrabold uppercase tracking-wider text-white transition-transform hover:-translate-y-0.5 sm:block">
          Check My Options
        </Link>
        <a href={`tel:${PHONE_TEL}`} aria-label="Call us" data-testid="mobile-phone"
          className="grid h-10 w-10 place-items-center rounded-full border border-border text-forest lg:hidden">
          <Phone className="h-4 w-4" />
        </a>
        <button aria-label="Menu" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}
          className="grid h-10 w-10 place-items-center rounded-full border border-border text-forest lg:hidden">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border bg-sand px-5 py-4 lg:hidden" data-testid="mobile-nav">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block py-3 text-base font-semibold text-forest">{l.label}</Link>
          ))}
          <Link to="/check-my-options" onClick={() => setOpen(false)} data-testid="mobile-cta"
            className="mt-3 block rounded-full bg-terracotta px-5 py-3 text-center text-xs font-extrabold uppercase tracking-wider text-white">
            Check My Options
          </Link>
        </div>
      )}
    </header>
  );
};
